<template>
  <div>
    <div class="management_top_box">
      <h4>{{ $t("management.documentTypeManagement") }}</h4>
      <div class="m_t_right">
        <!-- <dl>
          <dt>Language:</dt>
          <select
            name="language"
            class="int_type01 mgt_seltype"
            v-model="form.selectedLanguage"
            @change="changeLang()"
          >
            <option
              v-for="(item, index) in languages"
              :key="index"
              v-bind:value="item.codeId"
            >
              {{ item.codeName }}
            </option>
          </select>
        </dl> -->
        <button
          type="button"
          class="btn btn-secondary btn-sm m-2"
          @click="downExcel()"
          style="margin: 11px 0 0 0 !important"
        >
          <span class="bt_icon download_icon">Download</span>Excel Download
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-8 col-xl-12 col-xxl-8">
        <div class="mgt_group_box">
          <div class="mgt_group_title">
            <h4>{{ $t("product.documentType") }}</h4>
            <div class="group_bt_box">
              <a
                href="javascript:void(0)"
                class="mgt_g_icon01"
                @click="showChangeOrderPopup()"
                title="순위변경"
              >
                순위변경
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon02"
                @click="showAddDoctypePopup()"
                title="Type 추가"
              >
                추가
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon03"
                @click="showUpdateDoctypePopup(form.level1TypeId)"
                title="수정"
              >
                수정
              </a>
              <a
                href="javascript:void(0)"
                class="mgt_g_icon04"
                @click="clickDeleteDocType()"
                title="삭제"
              >
                삭제
              </a>
            </div>
          </div>
          <div class="mgt_list">
            <ul v-if="doctypeList">
              <li v-for="(item, index) in doctypeList" :key="index">
                <em
                  class="pointer_cursor m-4"
                  v-on:click="changeType(item.doctypeId)"
                  v-bind:class="{ on: item.doctypeId === form.level1TypeId }"
                >
                  {{ item.doctypeName }}
                </em>
                <p>
                  <button
                    type="button"
                    id=""
                    class="switch_btn"
                    data-toggle="button"
                    aria-pressed="false"
                    @click="
                      item.useYn = item.useYn === 'Y' ? 'N' : 'Y';
                      toggleUseYN(item.doctypeId, item.useYn);
                    "
                    v-bind:class="{ active: item.useYn === 'Y' }"
                  >
                    <span></span>
                  </button>
                  <!-- <span @click="showPreviewPopup(item.doctypeId)">이미지</span> -->
                  <span class="img_box" @click="showPreviewPopup(item.doctypeId)"
                    >이미지</span
                  >
                  <!--                  TODO : 이미지 html 바꾸기-->
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <ChangeOrderModal
      id="changeOrderModal"
      v-show="showOrderModal"
      @close="showOrderModal == false"
      ref="changeOrderModal"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveOrder"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </ChangeOrderModal>
    <AddDoctypeModal
      id="addDoctypeModal"
      ref="addDoctypeModal"
      v-show="showDocTypeModal"
      @close="showDocTypeModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="saveDoctype"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeAddDoctypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </AddDoctypeModal>
    <UpdateDoctypeModal
      id="updateDoctypeModal"
      ref="updateDoctypeModal"
      v-show="showUpdateModal"
      @close="showUpdateModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateDoctype"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateDoctypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </UpdateDoctypeModal>
    <PreviewModal
      id="previewModal"
      ref="previewModal"
      :typeId="form.level1TypeId"
      v-show="showPreviewModal"
      @close="showPreviewModal == false"
    >
      <template slot="footer">
        <button
          type="button"
          @click="updateDoctype"
          class="btn btn-primary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="closeUpdateDoctypeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </PreviewModal>
  </div>
</template>

<script>
import {
  docTypeList,
  deleteDocType,
  getLanguages,
  downExcel,
  changeDoctypeUse,
} from "@/api/doctype";
import ChangeOrderModal from "@/components/modal/ChangeOrderModal";
import PreviewModal from "@/components/modal/PreviewModal";
import AddDoctypeModal from "@/components/modal/AddDoctypeModal";
import UpdateDoctypeModal from "@/components/modal/UpdateDoctypeModal";

export default {
  components: {
    AddDoctypeModal,
    PreviewModal,
    ChangeOrderModal,
    UpdateDoctypeModal,
  },
  data() {
    return {
      doctypeList: [],
      languages: [],
      form: {
        level1TypeId: "",
        selectedLanguage: "",
      },
      showOrderModal: false,
      showDocTypeModal: false,
      showUpdateModal: false,
      showPreviewModal: false,
    };
  },
  created() {
    this.setUp();
  },
  methods: {
    async downExcel() {
      let result = await downExcel();

      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "DocTypeInfo.xls";
      link.click();
      window.URL.revokeObjectURL(url);
    },
    async changeLang() {
      await this.fetchData();
    },
    async toggleUseYN(doctypeId, useYn) {
      console.log(doctypeId);
      changeDoctypeUse({ id: doctypeId, useYn: useYn });
    },
    async setUp() {
      try {
        // const response = await docTypeList("en");
        const response = await docTypeList();
        this.doctypeList = response.data.doctypeList;

        // const langList = await getLanguages();
        // this.languages = langList.data.languages;
        // this.form.selectedLanguage = "en";
      } catch (error) {
        console.log(error);
      }
    },
    async fetchData() {
      try {
        const response = await docTypeList(this.form.selectedLanguage);
        this.doctypeList = response.data.doctypeList;

        const langList = await getLanguages();
        this.languages = langList.data.languages;
      } catch (error) {
        console.log(error);
      }
    },
    changeType: function (doctypeId) {
      console.log(doctypeId);
      this.form.level1TypeId = doctypeId;
    },
    async showChangeOrderPopup() {
      await this.$refs.changeOrderModal.fetchData();
      this.showOrderModal = true;
    },
    closeModal() {
      this.showOrderModal = false;
    },
    async saveOrder() {
      await this.$refs.changeOrderModal.saveOrder();
      await this.fetchData();
      this.showOrderModal = false;
    },

    async showAddDoctypePopup() {
      await this.$refs.addDoctypeModal.reset();
      await this.$refs.addDoctypeModal.fetchDoctypeForm();
      this.showDocTypeModal = true;
    },
    closeAddDoctypeModal() {
      this.showDocTypeModal = false;
    },
    async saveDoctype() {
      let data = await this.$refs.addDoctypeModal.save();
      if (data == false) {
        alert(this.$t("alert.ErrorPlzcontactManager"));
        return;
      } else if (data == true) {
        alert(this.$t("alert.savedSuccessfully"));
        this.$refs.addDoctypeModal.reset();
      } else if (data == "exist") {
        alert(this.$t("alert.alreadyExist"));
      } else if (data == "value") {
        alert(this.$t("alert.plzCheckAllValues"));
      }
      await this.fetchData();
      this.showDocTypeModal = false;
    },
    async showUpdateDoctypePopup(doctypeId) {
      if (this.form.level1TypeId === "") {
        alert(this.$t("alert.pleaseSelectADocumentType"));
      } else {
        await console.log(doctypeId);
        await this.$refs.updateDoctypeModal.fetchData(doctypeId);
        this.showUpdateModal = true;
      }
    },
    closeUpdateDoctypeModal() {
      this.showUpdateModal = false;
      this.showPreviewModal = false;
    },
    // doctype 수정
    async updateDoctype() {
      let data = await this.$refs.updateDoctypeModal.update();
      if (data != true) {
        alert(this.$t(data));
        return;
      } else {
        alert(this.$t("alert.changedSuccessfully"));
        this.$refs.updateDoctypeModal.reset();
      }
      await this.fetchData();
      this.showUpdateModal = false;
      this.showPreviewModal = false;
    },
    async showPreviewPopup(doctypeId) {
      await this.$refs.previewModal.fetchData(doctypeId);
      this.showPreviewModal = true;
    },
    async clickDeleteDocType() {
      if (!confirm(this.$t("alert.delete"))) return;

      const params = { doctypeId: this.form.level1TypeId };
      let response = await deleteDocType(params);

      if (response.data.result) {
        alert(this.$t("alert.deletedSuccessfully"));
        await this.fetchData();
      } else {
        alert(response.data.reason);
      }
    },
  },
};
</script>

<style></style>
